/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, useContext, useEffect } from 'react'

import { RoleEnum, User } from '@types'

type ContextState = {
  state: User | undefined
  setState: (newstate: User | undefined) => void
  roles: RoleEnum[] | undefined
}

const initialState = {
  state: undefined,
  setState: () => {},
  roles: undefined,
  setRoles: () => {},
}

const UserContext = React.createContext<ContextState>(initialState)

export function UserProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<User>()
  const [roles, setRoles] = useState<RoleEnum[]>()

  useEffect(() => {
    // Set the state of roles if exist user
    if (state) {
      setRoles(state.roles.map(role => role.name))
    }
  }, [state])

  return <UserContext.Provider value={{ state, setState, roles }}>{children}</UserContext.Provider>
}

export function useUser(): ContextState {
  const context = useContext(UserContext)
  if (!context) throw Error('This hook can only be used under the UserProvider component')
  return context
}
